// @ts-nocheck
/* global css */
import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { Collapse } from 'react-bootstrap';
import ProgressBar from '../../shared/progress-bar';
import { cssInJS } from '../../utils/styles';
import Button from '../../shared/button';
import MetadataParser from './helpers/metadata-parser';
import { ProgressEvent } from './media-props';

export const FILE_TYPE_ERROR = 'ERROR: One or more of your added files are not compatible with this media field';
interface Props {
  buttonText: string,
  disabled?: boolean,
  onMediaAdd: (metadata: Object, uploadedFile: Object) => void,
  uploadFile: (file: File,
    progress: (event: ProgressEvent) => void) => Promise<Object>,
  fileTypes?: string,
}

/**
 * @deprecated this file has been replaced by media-upload.tsx
 */
const MediaUpload: React.FC<Props> = ({
  buttonText,
  disabled = false,
  onMediaAdd,
  uploadFile,
  fileTypes = '',
}: Props) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const startUpload = async (file: File): Promise<Object> => {
    setUploading(true);

    const progressHandler = (e: ProgressEvent) => {
      if (e.lengthComputable) {
        setProgress(parseInt(e.percent, 10));
      }
    };

    let uploadedFile = null;
    try {
      uploadedFile = await uploadFile(file, progressHandler);
    } catch (ex: any) {
      setErrorMessage(ex.message);
      return {};
    } finally {
      // Reset uploading state regardless of success/error
      setUploading(false);
      setProgress(0);
    }

    setSuccessMessage('File successfully uploaded.');

    return uploadedFile;
  };

  const handleDrop = async (accepted: File[], rejected: File[]) => {
    if (rejected.length) {
      setErrorMessage(FILE_TYPE_ERROR);
      return;
    }
    const uploadedFile = await startUpload(accepted[0]);
    if (!uploadedFile) {
      return;
    }
    const metadata = new MetadataParser().parse(uploadedFile);

    onMediaAdd(metadata, uploadedFile);
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  return (
    <div className={css(styles.container)}>
      {errorMessage && <div className={styles.error}>{errorMessage}</div>}
      <Collapse in={!!successMessage}>
        <div className={styles.success}>{successMessage}</div>
      </Collapse>
      {uploading && (
        <div className={styles.progressContainer}>
          <ProgressBar progress={progress} />
        </div>
      )}
      {!disabled && (
        <Dropzone
          onDrop={handleDrop}
          disablePreview
          multiple={false}
          accept={fileTypes}
          className={css(styles.dropzone)}
          activeClassName={css(styles.dropActive)}
          rejectClassName={css(styles.dropReject)}
        >
          <Button affirm small>
            {buttonText}
          </Button>
        </Dropzone>
      )}
    </div>
  );
};

const styles = cssInJS({
  container: {
    verticalAlign: 'top',
  },

  dropzone: {
    display: 'inline-block',
    padding: 0,
    cursor: 'pointer',
    paddingTop: 0,
    paddingBottom: 10,
    width: '100%',
    marginBottom: 0,
  },

  dropActive: {
  },

  dropReject: {
  },

  progressContainer: {
    marginTop: 0,
    marginBottom: 12,
    marginRight: 10,
  },

  success: {
    backgroundColor: '#56b881',
    color: '#000',
    marginTop: 0,
    marginBottom: 12,
    marginRight: 10,
    padding: 8,
    borderRadius: 5,
  },

  error: {
    backgroundColor: '#e55e5e',
    color: '#000',
    marginTop: 0,
    marginBottom: 12,
    marginRight: 10,
    padding: 8,
    borderRadius: 5,
  },

});

export default MediaUpload;
